import React from 'react';
import { ArrowLeft, ArrowRight, Check, Loader2 } from 'lucide-react';

interface SurveyNavigationProps {
  currentPage: number;
  totalPages: number;
  isLastPage: boolean;
  isSubmitting: boolean;
  isSaving?: boolean;
  hasPendingChanges?: boolean;
  primaryColor: string;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export const SurveyNavigation: React.FC<SurveyNavigationProps> = ({
  currentPage,
  totalPages,
  isLastPage,
  isSubmitting,
  isSaving = false,
  hasPendingChanges = false,
  primaryColor,
  onPrevious,
  onNext,
  onSubmit,
}) => {
  const isDisabled = isSubmitting || isSaving || hasPendingChanges;
  
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mt-6 relative">
      {/* Saving indicator */}
      {(isSaving || hasPendingChanges) && (
        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 flex items-center text-sm text-gray-600 bg-white px-3 py-1 rounded-full shadow-sm">
          <Loader2 className="h-3 w-3 mr-1 animate-spin" />
          Saving changes...
        </div>
      )}
      
      <div className="flex justify-between items-center">
        <button
          type="button"
          onClick={onPrevious}
          disabled={currentPage === 0}
          className={`
            flex items-center px-4 py-2 rounded-lg transition-colors
            ${currentPage === 0
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }
          `}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Previous
        </button>

        {isLastPage ? (
          <button
            type="button"
            onClick={onSubmit}
            disabled={isDisabled}
            className="flex items-center px-6 py-2 text-white rounded-lg transition-colors relative"
            style={{
              backgroundColor: primaryColor,
              opacity: isDisabled ? 0.7 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Submitting...
              </>
            ) : (isSaving || hasPendingChanges) ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Check className="h-4 w-4 mr-2" />
                Submit Survey
              </>
            )}
          </button>
        ) : (
          <button
            type="button"
            onClick={onNext}
            disabled={isSaving || hasPendingChanges}
            className="flex items-center px-6 py-2 text-white rounded-lg transition-colors"
            style={{
              backgroundColor: primaryColor,
              opacity: (isSaving || hasPendingChanges) ? 0.7 : 1,
              cursor: (isSaving || hasPendingChanges) ? 'not-allowed' : 'pointer',
            }}
          >
            {(isSaving || hasPendingChanges) ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                Next
                <ArrowRight className="h-4 w-4 ml-2" />
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};